import { CatalogueAPI, DtoAuthorizeResponse } from "@configura/web-api";
import { Observable } from "@configura/web-utilities";
import React, { ReactNode, useRef } from "react";
import { DtoAPIError, DtoRequestOptions } from "./catadmin/InternalCatalogueAPI";

interface Props {
	children?: ReactNode;
	auth: DtoAuthorizeResponse;
}

export function APIContextProvider(props: Props) {
	const api = useRef<DebugAPI | undefined>();
	if (api.current === undefined) {
		api.current = new DebugAPI();
	}

	api.current.auth = props.auth;

	return <APIContext.Provider value={api.current}>{props.children}</APIContext.Provider>;
}

export class DebugAPI extends CatalogueAPI {
	observable = new Observable<unknown>();

	async fetch<T>(url: string, options: DtoRequestOptions): Promise<T> {
		try {
			const res = await super.fetch<T>(url, options);
			this.observable.notifyAll({ url, request: options, response: res });
			return res;
		} catch (e) {
			const body = e instanceof DtoAPIError ? e.body || "" : "";
			this.observable.notifyAll({ url, request: options, response: body || "", error: e });
			throw e;
		}
	}
}

export const APIContext = React.createContext<DebugAPI>(new DebugAPI());
